
import { Vue } from 'vue-property-decorator'

export default class Loader extends Vue {}
